import imgHive from "../images/work/work-hive.webp";
import imgMk2 from "../images/work/work-mk2.webp";
import imgAtmos from "../images/work/work-atmos.webp";
import imgVsc from "../images/work/work-vsc.webp";
import imgHood from "../images/work/work-portablehood.webp";
import imgAdditional from "../images/work/work-additional.webp";

// Single source of truth for the case studies: drives the home page cards and
// the prev/next navigation at the foot of every case study, so the two cannot
// drift apart. Order here is the order a reader walks through the work.
export const PROJECTS = [
  {
    slug: "/hive",
    title: "HIVE",
    blurb: "Filter-less air purification, now shipping on Amazon",
    img: imgHive,
    alt: "HIVE air purifier standing beside a bed in a bedroom",
  },
  {
    slug: "/mk2",
    title: "MK2 Application",
    blurb: "Device management interface for connected purifiers",
    img: imgMk2,
    alt: "MK2 application screens arranged around a laptop",
  },
  {
    slug: "/atmos",
    title: "ATMOS",
    blurb: "Steam cleaning device for gear and equipment",
    img: imgAtmos,
    alt: "ATMOS steam cleaning device detail render",
  },
  {
    slug: "/vsc",
    title: "VSC",
    blurb: "Vacuum sealing and steam cooking appliance",
    img: imgVsc,
    alt: "VSC appliance steam cooking salmon and vegetables",
  },
  {
    slug: "/portablehood",
    title: "Portable Hood",
    blurb: "Portable kitchen extraction hood",
    img: imgHood,
    alt: "Portable extraction hood product render",
  },
  {
    slug: "/additionalproject",
    title: "Additional Work",
    blurb: "Sketching, CAD and visualisation studies",
    img: imgAdditional,
    alt: "Speaker concept visualisation",
  },
];

export const projectIndex = (slug) => PROJECTS.findIndex((p) => p.slug === slug);

// Wraps, so the last project leads back to the first rather than dead-ending.
export const neighbours = (slug) => {
  const i = projectIndex(slug);
  if (i < 0) return { prev: null, next: null };
  return {
    prev: PROJECTS[(i - 1 + PROJECTS.length) % PROJECTS.length],
    next: PROJECTS[(i + 1) % PROJECTS.length],
  };
};
